
import React from "react";
import { z } from "zod";
import { clientFormSchema } from "@/contexts/ProgramCreationContext";
import { Client } from "./ClientSelection";
import { ClientDetailsWrapper } from "./client-details/ClientDetailsWrapper";

type ClientDetailsProps = {
  client: Client;
  onUpdateClientDetails: (data: z.infer<typeof clientFormSchema>) => Promise<void>;
  isSaving: boolean;
  onContinue: () => void;
};

export default function ClientDetails({
  client,
  onUpdateClientDetails,
  isSaving,
  onContinue
}: ClientDetailsProps) {
  return (
    <ClientDetailsWrapper 
      client={client} 
      onUpdateClientDetails={onUpdateClientDetails} 
      isSaving={isSaving} 
      onContinue={onContinue}
    />
  );
}
